import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom-v5-compat';
import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';
import { ButtonLoading } from '@/components/common';
import { useCheckAuthState, useDocumentFormData } from '@/hooks';
import { useSaveReceipt, useValidateReceipt } from '@/hooks/useSidebarActions';
import { SendIcon } from '@/resources/icons';
import useStyles from '../../styles';

const handleOnClick = async ({
    receipt,
    saveReceipt,
    onLoginBlocker,
    validateReceipt,
    onNegativeReceipt,
    registeredUser,
    setLoading,
    total,
    navigate
}) => {
    const receiptData = await validateReceipt(receipt);

    if (!receiptData) return;

    if (total < 0) {
        onNegativeReceipt();
        return;
    }

    const completePreviewProcess = async () => {
        setLoading(true);

        let savedData;
        if (receiptData?.documentState === 'draft') {
            savedData = await saveReceipt(receiptData, 'preview');
            if (savedData === false) {
                setLoading(false);
                return;
            }
        } else {
            savedData = { ...receiptData };
        }

        setLoading(false);

        if (savedData?.documentId !== null) {
            navigate(`/preview/${savedData?.documentId}`);
        }
    };

    // Check is a user is registered, if they are complete the process.
    // If not, see if we can get them to register.
    if (registeredUser) {
        completePreviewProcess();
    } else {
        onLoginBlocker(completePreviewProcess);
    }
};

const ReceiptPreviewAndSend = ({
    onNegativeReceipt,
    onLoginBlocker,
    setLoading,
    loading,
    isDesktop
}) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const { documentLoading, total } = useDocumentFormData();

    const { loadingUser, registeredUser } = useCheckAuthState();
    const saveReceipt = useSaveReceipt();
    const validateReceipt = useValidateReceipt();

    // Used for validation.
    const receipt = useSelector((state) => state?.makeInvoice);

    const loadingButton = loadingUser || documentLoading;

    return (
        <div className={classes.section}>
            {!loadingButton ? (
                <ButtonLoading
                    fullWidth
                    className={classes.primaryButton}
                    variant="contained"
                    color="primary"
                    endIcon={<SendIcon className={classes.buttonSendSvg} />}
                    size="large"
                    onClick={() =>
                        handleOnClick({
                            receipt,
                            saveReceipt,
                            onLoginBlocker,
                            validateReceipt,
                            onNegativeReceipt,
                            registeredUser,
                            setLoading,
                            total,
                            navigate
                        })
                    }
                    disableOnLoading
                    spinnerColor="primary"
                    loading={loading}
                    centerSpinner={!isDesktop}
                >
                    Preview & Send
                </ButtonLoading>
            ) : (
                <Skeleton variant="rectangular" className={classes.sizer} />
            )}
        </div>
    );
};

ReceiptPreviewAndSend.propTypes = {
    onNegativeReceipt: PropTypes.func.isRequired,
    onLoginBlocker: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    isDesktop: PropTypes.bool.isRequired
};

ReceiptPreviewAndSend.defaultProps = {
    loading: false
};

export default ReceiptPreviewAndSend;
